import { useEffect } from 'react';
import { ApolloError } from '@apollo/client';

// A data-fetching hook logs its own query failure here so no consumer re-adds a
// logging effect — consumers read `error` for control flow only. See REACT_CONVENTIONS.md.
export const useLogQueryError = (error: ApolloError | undefined, context: string): void => {
  useEffect(() => {
    if (error) console.error(`${context} failed:`, error);
  }, [error, context]);
};
